<template>
  <div>
    <v-container>
      <v-col cols="12" sm="12" offset-sm="0">
        <v-card class="maincard">
          <v-container>
            <v-row align="center">
              <v-col cols="12" xs="12" sm="6">
                <v-card-title>Benutzerverwaltung</v-card-title>
              </v-col>
              <v-col cols="12" xs="12" sm="6" style="text-align: right">
                <v-btn
                  small
                  @click="createIdCards()"
                  color="secondary"
                  class="mr-2"
                >
                  <v-icon style="margin-right: 10px">mdi-download</v-icon>
                  <span>ID Karten</span>
                </v-btn>
                <v-btn small to="/user/edit" color="success">
                  <v-icon style="margin-right: 10px">mdi-account-plus</v-icon>
                  <span>Neuer Benutzer</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>

          <UserList ref="UserList" />
        </v-card>
      </v-col>
    </v-container>
  </div>
</template>

<script>
import UserList from "@/components/users/UserList.vue";
import UserService from "@/services/UserService.js";
import moment from "moment";
import FileSaver from "file-saver";

export default {
  name: "UserMgmt",
  components: { UserList },
  methods: {
    createIdCards() {
      //this.$refs.UserList.createIdCards();
      this.$store.commit("SET_APP_LOADING", true);
      UserService.createIdCards()
        .then((response) => {
          let filename = "idcards_" + moment().format("YYYY-MM-DD") + ".pdf";
          const bytes = new Uint8Array(response.data);

          FileSaver.saveAs(
            new Blob([bytes], {
              type: "application/pdf;",
            }),
            filename
          );
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.$store.commit("SET_APP_LOADING", false);
        });
    },
  },
};
</script>

<style scoped></style>
